export type WorkspaceType = "group" | "team" | "teams" | "oneDrive" | "sharePointSite" | "teamsChannel" | "unknown"; // "unknown" should be removed once SGPD-2360 is completed

// Generic over the caller's workspace-type union (tenant-assessment's and reviews' generated
// unions differ); the casts are safe because each literal is returned only when proven present
// in the input array.
export function getMainWorkspaceType<T extends string>(workspaceTypes: T[]): T | "unknown" {
    const types: readonly string[] = workspaceTypes;

    if (types.includes("teams")) {
        return "teams" as T;
    }

    if (types.includes("oneDrive")) {
        return "oneDrive" as T;
    }

    if (types.includes("teamsChannel")) {
        return "teamsChannel" as T;
    }

    // after all the others
    if (types.includes("group")) {
        return "group" as T;
    }

    // the last fallback
    if (types.includes("sharePointSite")) {
        return "sharePointSite" as T;
    }

    return "unknown";
}
